import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DataService } from 'src/app/core/services/data.service';
import { UploadFileComponent } from '../upload-file/upload-file.component';

@Component({
  selector: 'app-import-user-file',
  templateUrl: './import-user-file.component.html'
})
export class ImportUserFileComponent implements OnInit, OnDestroy {

  @ViewChild(UploadFileComponent, {read: UploadFileComponent, static: false}) uploadFileComponent;
  haveFileUpload = false;
  haveErrorResult = false;

  private subscribeHaveFileUpload: any;
  private subscribeHaveErrorResult: any;

  constructor(
    private dataService: DataService,
    public dialogRef: MatDialogRef<ImportUserFileComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string
  ) {
  }

  ngOnInit() {
    this.subscribeHaveFileUpload = this.dataService.haveAttachFile.subscribe({
      next: (v) => {
        this.haveFileUpload = v;
      }
    });

    this.subscribeHaveErrorResult = this.dataService.haveErrorResult.subscribe({
      next: (v) => {
        this.haveErrorResult = v;
      }
    });

    this.dataService.imported.subscribe({
      next: (v) => {
        this.dialogRef.close();
      }
    });
  }

  ngOnDestroy() {
    this.subscribeHaveFileUpload.unsubscribe();
    this.subscribeHaveErrorResult.unsubscribe();
  }

  onUploadFileUser() {
    this.uploadFileComponent.uploadFile();
  }

  downFileTemplateExcelAddUser(e) {
    e.preventDefault();
    this.dataService.setDownFile(true);
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
